export const ManualEntryRecordActionTypes = {
    SET_RECORDS: "SETTING_BILLING_RECORDS_FOR_SELECTED_RANGE",
    SET_YEAR: "SELECTED_YEAR",
    SET_MONTH: "SELECTED_MONTH",
    CLEAR_MANUAL_BILLING_RECORDS: "CLEAR_MANUAL_BILLING_RECORDS",
}

export const BillingTypes = {
    INVOICE: "Invoice",
    CREDIT: "Credit"
}

export const BillingProductTypes = {
    INVOICE: {
        AVS: "AVS",
        IDV: "IDV",
        BV: "BV",
        LOCAL_VIEW: "Local View",
        PLATFORM_FEE: "Platform Fee",
        MIN_CO: "Minimum Commitment",
        IMPLEMENTATION_FEE: "IDV Implementation Fee",
    },
    CREDIT: {
        AVS_CREDIT: "AVS Credit",
        IDV_CREDIT: "IDV Credit",
        BV_CREDIT: "BV Credit",
        LOCAL_VIEW_CREDIT: "Local View Credit",
        PLATFORM_FEE_CREDIT: "Platform Fee Credit",
        MIN_CO_CREDIT: "Minimum Commitment Credit",
        IMPLEMENTATION_FEE_CREDIT: "IDV Implementation Fee Credit",
    }
}

export const addEditManualEntryRecordsActionTypes = {
    SET_ORG_TENANT_COUNTRIES: "SET_ORG_TENANT_COUNTRIES",
    CLOSE_RECORDS_MODAL: "CLOSE_RECORDS_MODAL",
    CLEAR_RECORDS_MODAL: "CLEAR_RECORDS_MODAL",
    TOGGLE_ADD_RECORDS_MODAL: "TOGGLE_ADD_RECORDS_MODAL",
    TOGGLE_EDIT_RECORDS_MODAL: "TOGGLE_EDIT_RECORDS_MODAL",
    SET_FORM_VALUE: "SET_FORM_VALUE",
    SET_BILLING_RECORDS_TYPE: "SET_BILLING_RECORDS_TYPE",
    SET_BILLING_RECORDS_PRODUCT: "SET_BILLING_RECORDS_PRODUCT",
    SET_BILLING_RECORDS_ORG: "SET_BILLING_RECORDS_ORG",
    SET_BILLING_RECORDS_TENANT: "SET_BILLING_RECORDS_TENANT",
    SET_BILLING_RECORDS_COUNTRY: "SET_BILLING_RECORDS_COUNTRY",
}

export const apiActionsManualEntryRecords = {
    VALIDATE_BILLING_RECORD: "VALIDATE_BILLING_RECORD",
    GET_RECORDS: "FETCH_ALL_MANUAL_ENTRY_BILLING_RECORDS",
    GET_ORG_TENANT_COUNTRIES: "GET_ORG_TENANT_COUNTRIES",
    POST: "ADD_NEW_MANUAL_ENTRY_BILLING_RECORD",
    PUT: "EDIT_MANUAL_ENTRY_BILLING_RECORD",
    DELETE_CURRENT_RECORD: "DELETE_MANUAL_ENTRY_BILLING_RECORD",
    DELETE_WARNING_FOR_RECORD: "DELETE_WARNING_FOR_RECORD",
}
